import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/keplrIcon2.png'
import _imports_1 from '@/assets/cosmostationIcon.png'
import _imports_2 from '@/assets/leapIcon.png'


const _withScopeId = n => (_pushScopeId("data-v-6fbe6999"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loginChoose__holder" }
const _hoisted_2 = { class: "top-bar" }
const _hoisted_3 = { style: {"font-weight":"bold"} }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "mx-2" }
const _hoisted_6 = {
  href: "/terms_conditions",
  target: "_blank"
}
const _hoisted_7 = {
  href: "/privacy_policy",
  target: "_blank"
}
const _hoisted_8 = { class: "loginChoose__body" }
const _hoisted_9 = { class: "iconContainer" }
const _hoisted_10 = {
  style: {"margin-left":"auto"},
  class: "nextStep"
}
const _hoisted_11 = {
  class: "iconContainer",
  style: {"background-color":"#72bf44"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"25px","margin-right":"20px"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"height":"50px","padding-top":"6px"},
    src: _imports_0
  })
], -1 /* HOISTED */))
const _hoisted_13 = {
  style: {"margin-left":"auto"},
  class: "nextStep"
}
const _hoisted_14 = {
  class: "iconContainer",
  style: {"background-color":"#72bf44"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"25px","margin-right":"20px"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"height":"50px","padding-top":"6px"},
    src: _imports_1
  })
], -1 /* HOISTED */))
const _hoisted_16 = {
  style: {"margin-left":"auto"},
  class: "nextStep"
}
const _hoisted_17 = {
  class: "iconContainer",
  style: {"background-color":"#72bf44"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"25px","margin-right":"20px"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"height":"50px","padding-top":"6px"},
    src: _imports_2
  })
], -1 /* HOISTED */))
const _hoisted_19 = {
  style: {"margin-left":"auto"},
  class: "nextStep"
}
const _hoisted_20 = {
  class: "iconContainer",
  style: {"background-color":"#72bf44"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_Icon = _resolveComponent("Icon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('CONNECT.WELCOME')), 1 /* TEXT */),
      _createVNode(_component_Button, {
        icon: "pi pi-times",
        style: {"margin-bottom":"0.5rem"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
        class: "p-button-rounded p-button-secondary p-button-text"
      })
    ]),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t('CONNECT.WELCOME_MESSAGE')), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_4, [
      _createVNode($setup["Checkbox"], {
        name: "termsAccepted",
        modelValue: $setup.termsAccepted,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.termsAccepted) = $event)),
        binary: true
      }, null, 8 /* PROPS */, ["modelValue"]),
      _createElementVNode("span", _hoisted_5, [
        _createVNode(_component_i18n_t, {
          keypath: "CONNECT.CONNECT_TERMS",
          tag: "label"
        }, {
          default: _withCtx(() => [
            _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$t('CONNECT.CONNECT_TERMS_LINK_TERMS')), 1 /* TEXT */),
            _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t('CONNECT.CONNECT_TERMS_LINK_POLICY')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
      ($setup.props.showAddressOption)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["box", {'box__inactive': !$setup.termsAccepted}]),
            onClick: _cache[2] || (_cache[2] = () => {if ($setup.termsAccepted) _ctx.$emit('typeChange', $setup.LoginEmail)})
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Icon, {
                class: "icon",
                name: "Globe"
              })
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('CONNECT.CONNECT_ADDRESS')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Icon, {
                  style: {"color":"white"},
                  class: "icon",
                  name: "ArrowRightCircle"
                })
              ])
            ])
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      (!$setup.isMobile())
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            style: {"margin-top":"10px"},
            class: _normalizeClass(["box", {'box__inactive': !$setup.termsAccepted}]),
            onClick: _cache[3] || (_cache[3] = () => {if ($setup.termsAccepted) _ctx.$emit('keplr')})
          }, [
            _hoisted_12,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('CONNECT.CONNECT_KEPLR')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Icon, {
                  style: {"color":"white"},
                  class: "icon",
                  name: "ArrowRightCircle"
                })
              ])
            ])
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      (!$setup.isMobile())
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            style: {"margin-top":"10px"},
            class: _normalizeClass(["box", {'box__inactive': !$setup.termsAccepted}]),
            onClick: _cache[4] || (_cache[4] = () => {if ($setup.termsAccepted) _ctx.$emit('cosmostation')})
          }, [
            _hoisted_15,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('CONNECT.CONNECT_COSMOSTATION')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_Icon, {
                  style: {"color":"white"},
                  class: "icon",
                  name: "ArrowRightCircle"
                })
              ])
            ])
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      (!$setup.isMobile())
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            style: {"margin-top":"10px"},
            class: _normalizeClass(["box", {'box__inactive': !$setup.termsAccepted}]),
            onClick: _cache[5] || (_cache[5] = () => {if ($setup.termsAccepted) _ctx.$emit('leap')}  )
          }, [
            _hoisted_18,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('CONNECT.CONNECT_LEAP')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_Icon, {
                  style: {"color":"white"},
                  class: "icon",
                  name: "ArrowRightCircle"
                })
              ])
            ])
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true)
    ])), [
      [
        _directive_tooltip,
        { value: _ctx.$t('CONNECT.ACCEPT_TERMS') , disabled: $setup.termsAccepted },
        void 0,
        { bottom: true }
      ]
    ])
  ]))
}